module.exports = __webpack_public_path__ + "img/Hasacha-Moureen.922dcbaa.jpeg";